import React from 'react';
import { X } from 'react-feather';
import { Logo } from './Logo';
import { NavItem } from './NavItem';
export function MobileMenu({
  isOpen,
  onClose,
  activePage,
  onNavigate
}: {
  isOpen: boolean;
  onClose: () => void;
  activePage: string;
  onNavigate: (page: string) => void;
}) {
  const isCaseStudy = activePage.startsWith('work/');
  return <div className={`fixed inset-0 bg-[#111111] z-50 transition-opacity duration-700 ease-in-out
        ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} data-id="element-152">
      <div className="flex flex-col h-full" data-id="element-153">
        <div className="h-[80px] flex items-center justify-between px-8" data-id="element-154">
          <Logo onClick={() => {
          onNavigate('home');
          onClose();
        }} data-id="element-155" />
          <button onClick={onClose} className="p-2 rounded-full hover:bg-white text-white hover:text-[#111111] transition-all duration-300 transform hover:scale-105" aria-label="Close menu" data-id="element-156">
            <X size={24} strokeWidth={2} data-id="element-157" />
          </button>
        </div>
        <nav className="flex-1 py-12 px-8" data-id="element-158">
          <ul className="space-y-6 flex flex-col items-start" data-id="element-159">
            {isCaseStudy ? <li className="w-full" data-id="element-160">
                <NavItem label="Turning rules into a workflow brokers can clear" isActive={true} onClick={() => {
              onNavigate('work/required-actions');
              onClose();
            }} isMobile={true} data-id="element-161" />
              </li> : <>
                <li className="w-full" data-id="element-162">
                  <NavItem label="The problem behind the problem" isActive={activePage === 'complexity'} onClick={() => {
                onNavigate('complexity');
                onClose();
              }} isMobile={true} data-id="element-163" />
                </li>
                <li className="w-full" data-id="element-164">
                  <NavItem label="Turning research into decisions" isActive={activePage === 'research'} onClick={() => {
                onNavigate('research');
                onClose();
              }} isMobile={true} data-id="element-165" />
                </li>
                <li className="w-full" data-id="element-166">
                  <NavItem label="Building systems that last" isActive={activePage === 'systems'} onClick={() => {
                onNavigate('systems');
                onClose();
              }} isMobile={true} data-id="element-167" />
                </li>
              </>}
          </ul>
        </nav>
        <div className="px-8 py-6 flex justify-between items-center" data-id="element-168">
          <p className="text-fluid-sm text-[#7A8290]" data-id="element-169">© All rights reserved</p>
          <a href="https://www.linkedin.com/in/mintextract/" target="_blank" rel="noopener noreferrer" className="text-fluid-sm text-[#7A8290] hover:text-white transition-colors duration-300" data-id="element-170">
            LinkedIn
          </a>
        </div>
      </div>
    </div>;
}